import { createNamedOptionChoice, fetchNamedOptionChoices } from "features/settings/api/namedOptionResource";
import { comorbidityResource } from "features/settings/constants/healthSelectionResources";

export const fetchComorbidities = async (search: string) => {
  return fetchNamedOptionChoices(comorbidityResource, search);
};

export const createComorbidity = async (name: string) => {
  return createNamedOptionChoice(comorbidityResource, name);
};
